import Model from "@/app/models/Concerns/Model";
import Question from './Question';
import {AxiosResponse} from "axios";
import Client from "@/app/Http/Client";

export default class Checklist extends Model {
    station_id!: number;
    brand_id!: number;
    open_till!: string;
    name!: string;
    comment!: string | null;
    signature!: string | null;
    private _questions?: Question[];

    public get pdfUrl(): string {
        return Client.baseUrl + '/checklists/' + this.id + '/pdf';
    }

    public get questions(): Question[] {
        return this._questions || [];
    }

    public set questions(question: Question[]) {
        this._questions = question.map(item => new Question(item));
    }

    public get dates() {
        return ['open_till'];
    }

    public static async for(productionOrder: number, brand: number): Promise<Checklist> {
        const response: AxiosResponse<{ data: Model }> = await Client.get(
            [this.table, 'for'].join('/'),
            {
                params: {
                    productionOrder,
                    brand,
                },
            }
        );

        return new Checklist(response.data.data);
    }

    public async reopen<T>(): Promise<AxiosResponse<T>>
    {
        return Client.post(`/checklists/${this.id}/reopen`);
    }

    public async partialSave<T>(): Promise<AxiosResponse<T>>
    {
        return Client.patch(`/checklists/${this.id}/partial`, {
            comment: this.comment,
            _questions: this.questions,
        });
    }

    getTable(): string {
        return "checklists";
    }
}
